import { LEARNING_HUB_ROUTE } from 'config'

/**
 * Path to the auto-created Course Forum discussion for a course, when present.
 * Falls back to the forum index if the course has no linked discussion yet.
 *
 * @param {object|undefined} course — from fetchLearningHubCourse
 * @returns {string}
 */
export function courseForumPath(course) {
  const discussionId = course?.courseForumDiscussionId
  if (discussionId) {
    return `${LEARNING_HUB_ROUTE}/forum/discussions/${discussionId}`
  }
  return `${LEARNING_HUB_ROUTE}/forum`
}
